import { Actions } from '../actions/workItemSubscription';
import { cloneDeep } from 'lodash-es';

const workItemSubscriptionReducer = (state = [], action: any) => {
  switch (action.type) {
    case Actions.SET_WORKITEMSUBSCRIPTION:
      return {
        ...state,
        workItemSubscriptions: cloneDeep(action.payload),
      };
    default:
      return { ...state };
  }
};
export default workItemSubscriptionReducer;
